module.exports = __webpack_public_path__ + "img/Convertible_Side_Left.1d857540.svg";